import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";
import { LoadingOutlined } from "@/utils/antdIcon";
import { Modal, Form, Input, Radio, Space, Upload, Button, message, Select } from "antd";
import "./index.less";
import api from "../../api";
import events from "../../context/events";

// const { Option } = Select;

interface IProps {
  visible: boolean;
  appRuntimeEnv: any;
  removeNode?: () => void;
}

const KnowledgeModal = (props: IProps) => {
  const { visible, appRuntimeEnv, removeNode } = props;
  const [form] = Form.useForm();
  const defaultIconURL = appRuntimeEnv.joyspaceHost + "/static/icons/Webicon/wiki.png";
  const [loading, setLoading] = useState<boolean>(false);
  const [modalVisible, setModalVisible] = useState<boolean>(visible);
  const [imageUrl, setImageUrl] = useState(defaultIconURL);
  const [isUploading, setIsUploading] = useState(false);

  const handleOnOk = () => {
    form
      .validateFields()
      .then((values) => {
        setLoading(true);
        const loadingMsg = message.loading({
          content: "知识库创建中，请稍后...",
          key: "creatingKnowledge",
          duration: 0
        });
        const filterValues = JSON.parse(JSON.stringify(values)); // 过滤掉值为undefined
        api.wiki
          .createWiki({
            ...filterValues,
            parent: "kl"
          })
          .then((res) => {
            const { code, status, data } = res;
            if (code === "200") {
              setModalVisible(false);
              removeNode?.();
              message.success({
                content: "知识库创建成功",
                key: "creatingKnowledge",
                duration: 2
              });
              events.emit("wiki:refreshList");
            } else {
              message.error(status);
              loadingMsg();
            }
          })
          .catch((err) => {
            console.log(err);
            loadingMsg();
          })
          .finally(() => {
            setLoading(false);
          });
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const handleOnCancel = () => {
    setModalVisible(false);
    removeNode?.();
    form.resetFields();
  };

  const handleBeforeUpload = (file: any) => {
    const allowedFormats = ["image/png", "image/jpeg"].includes(file.type);
    const isLt10M = file.size / 1024 / 1024 < 10;

    if (!allowedFormats) {
      message.error("只能上传 PNG 或 JPG 格式的图片");
      return false;
    }
    if (!isLt10M) {
      message.error("图片大小不超过10MB");
      return false;
    }
    return true;
  };

  const handleImageUpload = async (options: any) => {
    setIsUploading(true);
    const { file } = options;

    if (!handleBeforeUpload(file)) {
      setIsUploading(false);
      return;
    }
    try {
      const formData = new FormData();
      formData.append("file", file);

      api.wiki.uploadIcon(formData).then((res) => {
        const { code, status, data } = res;
        if (code === "200") {
          setImageUrl(data.url);
          form.setFieldsValue({ icon: data.id });
        } else {
          message.error(status);
        }
        setIsUploading(false);
      });
    } catch (error) {
      console.log(error);
      setIsUploading(false);
    }
  };

  const getUploadButton = useMemo(() => {
    return isUploading ? (
      <LoadingOutlined style={{ marginLeft: "20px" }} />
    ) : (
      <>
        <img src={imageUrl} style={{ width: "45px", height: "45px", borderRadius: "5px" }} />
        <Upload showUploadList={false} customRequest={handleImageUpload}>
          <Button type="link" className="change-icon-btn">
            更换图标
          </Button>
        </Upload>
      </>
    );
  }, [isUploading, imageUrl]);

  // const handleDivClick = () => {
  //   form.setFieldsValue({ visibility: "private" });
  // };

  // const handleRadioChange = (e: any) => {
  //   form.setFieldsValue({ visibility: e.target.value });
  // };

  return (
    <Modal
      title="新建知识库"
      confirmLoading={loading}
      destroyOnClose={true}
      maskClosable={false}
      visible={modalVisible}
      onOk={handleOnOk}
      onCancel={handleOnCancel}
      okText="新建"
      cancelText="取消"
      width={610}
    >
      <Form
        className="create-knowledge-form"
        form={form}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 17 }}
      >
        <Form.Item
          name="name"
          label="名称"
          rules={[
            {
              required: true,
              message: "名称不能为空"
            },
            {
              max: 50,
              message: "名称不能超过50个字"
            }
          ]}
        >
          <Input placeholder="请输入知识库名称" autoComplete="off" />
        </Form.Item>
        <Form.Item name="icon" label="图标">
          {getUploadButton}
        </Form.Item>
        <Form.Item
          name="description"
          label="简介"
          rules={[
            {
              max: 50,
              message: "简介不能超过50个字"
            }
          ]}
        >
          <Input placeholder="请输入知识库简介" autoComplete="off" />
        </Form.Item>
        {/* <Form.Item
          name="unit"
          label="归属单位"
          rules={[
            {
              required: true,
              message: "归属单位不能为空!"
            }
          ]}
        >
          <Input autoComplete="off" />
        </Form.Item>
        <Form.Item name="category" label="分类">
          <Select>
            <Option value="未分类">未分类</Option>
            <Option value="a类">a类</Option>
            <Option value="b类">b类</Option>
          </Select>
        </Form.Item> */}
        <Form.Item name="visibility" label="可见范围">
          <span className="ant-form-text">
            仅知识库成员可见
            <span style={{ fontSize: "12px", color: "#8F959E", marginLeft: "9px" }}>
              创建成功后可添加成员
            </span>
          </span>
          {/* <Radio.Group style={{ marginTop: "5px" }} onChange={handleRadioChange}>
            <Space direction="vertical" size={10}>
              <div style={{ display: "flex" }}>
                <Radio value="private" />
                <div onClick={handleDivClick} style={{ cursor: "pointer" }}>
                  仅知识库成员可见
                  <br />
                  <span>创建成功后可添加成员</span>
                </div>
              </div>
              <Radio value="public">“#租户名#”内所有成员均可见</Radio>
            </Space>
          </Radio.Group> */}
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default function (props: IProps) {
  const ele = document.createElement("div");
  document.body.appendChild(ele);
  function removeNode() {
    if (ele) {
      ReactDOM.unmountComponentAtNode(ele);
      ele.remove();
    }
  }
  ReactDOM.render(<KnowledgeModal {...{ ...props }} removeNode={removeNode} />, ele);
}
